import React, { useEffect, useState } from 'react';
import './spinner-style.css';
import { FaSpinner } from 'react-icons/fa';
import higherMindLogo from '../assets/images/logo.png';
import { useLocation } from 'react-router-dom';

// Function to detect if the user is on an iOS or Android device
const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return 'desktop';
};

const RedirectToAppPage = () => {
  const [platform, setPlatform] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const { password, email } = location.state || {}

  useEffect(() => {
    const device = detectDevice();
    setPlatform(device); // Set platform as Android, iOS, or desktop
  }, []);

  const onFailure = () => {
    console.log('Failed to open the app. Redirecting to store...');
    setLoading(false);
  }

  const onSuccess = () => {
    console.log('App opened successfully!');
    setLoading(false);
  }

  // Function to handle the button click
  const handleRedirect = (callback) => {
    setLoading(true)
    const timeout = 2000; // Set a timeout of 3 seconds to detect if the app opens

    if (platform === 'android') {
      // Attempt to open the app using the custom URL scheme
      const startTime = Date.now();
      const encodeEmail = encodeURIComponent(email);
      const encodePassword = encodeURIComponent(password);
      window.location.href = `highermind://login/AUTOMATED_LOGIN/${encodeEmail}/${encodePassword}`; // Android app link

      // If the app doesn't open within the timeout, redirect to the Play Store
      setTimeout(() => {
        if (Date.now() - startTime < timeout + 100) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.mindfulselfdiscipline'; // Redirect to Play Store
          callback && onFailure(); // Execute failure callback
        } else {
          callback && onSuccess(); // Execute success callback if app opened
        }
      }, timeout);
    } else if (platform === 'ios') {
      // Attempt to open the app using the custom URL scheme
      const startTime = Date.now();
      const encodeEmail = encodeURIComponent(email);
      const encodePassword = encodeURIComponent(password);
      window.location.href = `highermind://login/AUTOMATED_LOGIN/${encodeEmail}/${encodePassword}`; // iOS app link

      // If the app doesn't open within the timeout, redirect to the App Store
      setTimeout(() => {
        if (Date.now() - startTime < timeout + 100) {
          window.location.href = 'https://apps.apple.com/app/higher-mind/id1557827729'; // Redirect to App Store
          callback && onFailure(); // Execute failure callback
        } else {
          callback && onSuccess(); // Execute success callback if app opened
        }
      }, timeout);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img alt="Higher Mind logo" src={higherMindLogo} width={100} height={100} style={{ borderRadius: 20 }} />
        {platform === 'desktop' ? (
          <>
            <p style={styles.message}>You are currently on a desktop.</p>
            <p style={styles.message}>To continue, please install and use the Higher Mind app on a mobile device.</p>
          </>
        ) : (
          <>
            <h2 style={styles.title}>Welcome to Higher Mind!</h2>
            <p style={styles.subText}>Press the button to open the app:</p>
            <button
              onClick={() => handleRedirect(() => { console.log('Callback executed'); })}
              style={styles.button}
            >
              {loading ? (
                <FaSpinner className="spinner" style={{ fontSize: '1.5rem' }} />
              ) : (
                'Open Higher Mind'
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    margin: 0,
    padding: '1rem',
    backgroundColor: '#f7f7f7',
    overflow: 'hidden',
  },
  card: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
    width: '500px',
    boxSizing: 'border-box',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    marginBottom: '1rem',
    textAlign: 'center',
    color: '#222',
  },
  subText: {
    fontSize: '0.95rem',
    marginBottom: '1rem',
    color: '#555',
  },
  message: {
    fontSize: '17px'
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#f3c300',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
    fontWeight: 'bold',
  },
};

export default RedirectToAppPage;
